/**
 * Generated runtime TestId mirror for frontend/src/components/ui/tag-input.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TagInputTestIds = {
  validationError: "validation-error",
  validationHint: "validation-hint",
  input: (root: string) => `${root}-input`,
  remove: (root: string, index: number) => `${root}-remove-${index}`,
  removePrefix: (root: string) => `${root}-remove-` as TestIdPrefix,
  suggestion: (root: string, s_code: string) => `${root}-suggestion-${s_code}`
} as const;
